import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { decorateWith, withName } from 'helpers/decorator';
import { getFirstError } from 'helpers/forms';
import { ga } from 'helpers/multitrack';
import { isEmpty } from 'helpers/verify';
import { waitlistRequest } from 'redux/saga/entities/bound';
import { LeadGenForm } from 'features/LeadGenForm/LeadGenForm';
import { WaitlistFormValidator } from './WaitlistFormValidator';
import { joinWaitlist } from './location.saga';
var messages = defineMessages({
  locationCta: {
    id: 'location-modal.waitlist-cta',
    defaultMessage: 'Keep me updated'
  }
});
export var WaitlistForm =
/*#__PURE__*/
function (_Component) {
  _inherits(WaitlistForm, _Component);

  function WaitlistForm() {
    _classCallCheck(this, WaitlistForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(WaitlistForm).apply(this, arguments));
  }

  _createClass(WaitlistForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ga('Geo_Detection_Modal', 'viewed_lead_gen', '', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      return React.createElement("div", {
        className: "location-modal--waitlist-form"
      }, React.createElement("h2", {
        className: "location-modal__title"
      }, React.createElement(FormattedMessage, {
        id: "location-modal.waitlist-header",
        defaultMessage: "We\u2019re not there yet"
      })), React.createElement("p", {
        className: "location-modal__subtitle"
      }, React.createElement(FormattedMessage, {
        id: "location-modal.waitlist-subtitle",
        defaultMessage: "But we hope to be! Share your email and we\u2019ll let you know when we\u2019re available near you."
      })), React.createElement(LeadGenForm, _extends({}, this.props, {
        intl: intl,
        ctaCopy: intl.formatMessage(messages.locationCta),
        hideLocation: true,
        singleLineBreakpoint: "none"
      })));
    }
  }]);

  return WaitlistForm;
}(Component);
WaitlistForm.propTypes = _objectSpread({}, LeadGenForm.propTypes);
var formConfig = {
  form: 'locationModalWaitlist',
  validate: WaitlistFormValidator
};
var getError = getFirstError(formConfig.form);
export var mapStateToProps = function mapStateToProps(state) {
  return {
    formError: getError(state) || waitlistRequest.error(state),
    wasCaptured: !isEmpty(waitlistRequest.data(state))
  };
};
export var mapDispatchToProps = {
  onWaitlistRequest: joinWaitlist
};
export var WaitlistFormContainer = decorateWith(injectIntl, reduxForm(formConfig), withName('WaitlistForm'), connect(mapStateToProps, mapDispatchToProps))(WaitlistForm);